module.exports = __webpack_public_path__ + "static/media/store.930964ca.svg";